import { produce } from 'immer'
import { IssuerListResponse } from 'src/models/issuer.models'
import {
  GET_CSP_ME_SUCCESS,
  GetCspMeSuccessAction,
  POST_CSP_LOGIN_SUCCESS,
  PostCspLoginSuccessAction,
} from 'src/redux/actions/auth.actions'

export interface IssuersState {
  listResponses: Record<string, IssuerListResponse>
}

export const initialState: IssuersState = {
  listResponses: {},
}

export type Actions = PostCspLoginSuccessAction | GetCspMeSuccessAction

const IssuersReducer = (
  state: IssuersState = initialState,
  action: Actions,
): IssuersState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case GET_CSP_ME_SUCCESS:
      case POST_CSP_LOGIN_SUCCESS: {
        draft.listResponses = action.payload.issuers.reduce(
          (acc, curr) => ({
            ...acc,
            [curr.id]: curr,
          }),
          {},
        )
        return draft
      }
    }
  })
}

export default IssuersReducer
